import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RelayDashboardRoutingModule } from './relay-dashboard-routing.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { CardTableModule } from 'libs/portal/src/modules/tools/card-table/card-table.module';
import { RelayDashboardComponent } from './relay-dashboard/relay-dashboard.component';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@NgModule({
  declarations: [RelayDashboardComponent],
  imports: [CommonModule, RelayDashboardRoutingModule, MatExpansionModule, CardTableModule, MaterialModule],
})
export class RelayDashboardModule {}
